// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__PBIW1","icon":"SearchInput_icon__5ox7Q","input":"SearchInput_input__RKqZe"};